import Cookies from 'js-cookie';

export default {
    init() {

        let customer_id = Cookies.get('bs_customer_id');
        let department_id = Cookies.get('bs_active_department_id');
        let user_id = Cookies.get('bs_user_id');

        window.bs_ga_key = customer_id + '-' + department_id + '-' + user_id;

        window.dataLayer = window.dataLayer || [];

        function gtag(){ dataLayer.push(arguments); }

        gtag('js', new Date());

        gtag('set', {'user_id': window.bs_ga_key});

        gtag('config', 'UA-106576067-3');
    }
}
